// src/utils/tracking/google.js
export const loadGoogleTag = () => {
  // Only load Google Tag in production
  const clientDomain = process.env.REACT_APP_CLIENT_DOMAIN;
  const isProduction =
    clientDomain && clientDomain.includes("www.plaintr.com");

  if (!isProduction || window.gtag) return;


  const script = document.createElement("script");
  script.async = true;
  script.src =
    "https://www.googletagmanager.com/gtag/js?id=AW-17632627982";

  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };

  window.gtag("js", new Date());
  window.gtag("config", "AW-17632627982");
};
